/* JUSTYOL — drop product page. Before launch: countdown + save (handled by
   native-wishlist.js on the .wishlist-btn) + share. At launch: flip to buyable
   (add to cart → COD express). At launch the save/share bar is replaced by the
   buy bar (toBuyable hides the teaser actions to keep the footer uncrowded). */
(function () {
  'use strict';
  var root = document.querySelector('[data-jy-drop-product]');
  if (!root || root.__jyDP) return;
  root.__jyDP = true;

  var isAr = root.getAttribute('data-ar') === '1';
  var vid = root.getAttribute('data-vid');
  var title = root.getAttribute('data-title') || '';
  function t(fr, ar) { return isAr ? ar : fr; }

  var cd = root.querySelector('[data-jydp-cd]');
  var teaser = root.querySelector('[data-jydp-teaser]');
  var teaserInfo = root.querySelector('[data-jydp-teaser-info]');
  var buy = root.querySelector('[data-jydp-buy]');
  var eyebrow = root.querySelector('[data-jydp-eyebrow]');
  var addBtn = root.querySelector('[data-jydp-add]');
  var shareBtn = root.querySelector('[data-jydp-share]');
  var toast = root.querySelector('[data-jydp-toast]');

  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg; toast.hidden = false;
    setTimeout(function () { toast.hidden = true; }, 2600);
  }

  /* ---- gallery thumbs ---- */
  var stageImg = root.querySelector('.jydp__img');
  root.querySelectorAll('[data-jydp-thumb]').forEach(function (th) {
    th.addEventListener('click', function () {
      var img = th.querySelector('img');
      if (img && stageImg) { stageImg.src = img.src.replace(/width=140/, 'width=900'); stageImg.srcset = ''; }
      root.querySelectorAll('[data-jydp-thumb]').forEach(function (o) { o.classList.remove('is-on'); });
      th.classList.add('is-on');
    });
  });

  /* ---- description clamp / "read more" ---- */
  var desc = root.querySelector('[data-jydp-desc]');
  var moreBtn = root.querySelector('[data-jydp-more]');
  if (desc && moreBtn) {
    // only offer expand when the content is actually taller than the clamp
    if (desc.scrollHeight > desc.clientHeight + 8) {
      moreBtn.hidden = false;
    } else {
      desc.classList.remove('is-clamped');
    }
    moreBtn.addEventListener('click', function () {
      desc.classList.remove('is-clamped');
      moreBtn.hidden = true;
    });
  }

  /* ---- launch state (Morocco +01:00) ---- */
  var raw = (root.getAttribute('data-drop-date') || '').trim();
  var dropMs = 0;
  if (raw) {
    if (!/[zZ]|[+-]\d\d:?\d\d$/.test(raw)) raw = raw.replace(' ', 'T') + '+01:00';
    var p = Date.parse(raw);
    if (!isNaN(p)) dropMs = p;
  }
  var launched = !dropMs || Date.now() >= dropMs;

  var cells = {
    d: root.querySelector('[data-cd="d"]'), h: root.querySelector('[data-cd="h"]'),
    m: root.querySelector('[data-cd="m"]'), s: root.querySelector('[data-cd="s"]')
  };
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function toBuyable() {
    launched = true;
    if (cd) cd.hidden = true;
    if (teaser) teaser.hidden = true; // save/share give way to the buy bar
    if (teaserInfo) teaserInfo.hidden = true; // "how it works" is pre-launch only
    if (buy) buy.hidden = false;
    if (eyebrow) eyebrow.textContent = t('🔥 En vente — quantité limitée', '🔥 محلول دابا · كمية محدودة');
  }

  var timer = null;
  function tick() {
    if (!dropMs || Date.now() >= dropMs) { toBuyable(); if (timer) { clearInterval(timer); timer = null; } return; }
    var s = Math.max(0, Math.floor((dropMs - Date.now()) / 1000));
    if (cells.d) cells.d.textContent = pad(Math.floor(s / 86400));
    if (cells.h) cells.h.textContent = pad(Math.floor((s % 86400) / 3600));
    if (cells.m) cells.m.textContent = pad(Math.floor((s % 3600) / 60));
    if (cells.s) cells.s.textContent = pad(s % 60);
  }

  if (launched) {
    toBuyable();
  } else {
    tick();
    timer = setInterval(tick, 1000);
  }

  /* ---- share ---- */
  if (shareBtn) {
    shareBtn.addEventListener('click', function () {
      var url = location.href;
      if (navigator.share) {
        navigator.share({ title: title, text: t('Regarde cette offre sur Justyol 👀', 'شوف هاد العرض فجاستيول 👀'), url: url })
          .catch(function () {});
      } else if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () {
          showToast(t('Lien copié ✓', 'تنسخ اللينك ✓'));
        }, function () {});
      } else {
        showToast(url);
      }
    });
  }

  /* ---- buy (after launch) → cart + COD express ---- */
  function openExpress() {
    var trg = document.createElement('button');
    trg.setAttribute('data-jy-cta', 'express');
    trg.style.display = 'none';
    document.body.appendChild(trg);
    trg.click();
    setTimeout(function () { trg.remove(); }, 0);
  }
  if (addBtn) {
    var added = false;
    addBtn.addEventListener('click', function () {
      if (!launched) return;
      /* already in the cart (shopper closed the popup and came back) → just
         re-open express, never disable the button dead or add a duplicate line */
      if (added) { openExpress(); return; }
      addBtn.disabled = true; addBtn.classList.add('is-loading');
      var routes = (window.FoxTheme && FoxTheme.routes) || {};
      fetch((routes.cart_add_url || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: vid, quantity: 1 })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          addBtn.classList.remove('is-loading');
          addBtn.disabled = false; // always re-enable so the CTA never dies
          if (!res.ok) {
            showToast((res.j && res.j.description) || t('Rupture de stock', 'سالى الستوك'));
            return;
          }
          added = true;
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          openExpress();
        })
        .catch(function () {
          addBtn.disabled = false; addBtn.classList.remove('is-loading');
          showToast(t('Erreur réseau, réessayez', 'مشكل فالشبكة، عاود'));
        });
    });
  }
})();
